import { downloadFileInBrowser } from '@/utils/CsvExport.ts';

export function downloadBase64File (base64File: string, filename: string, mimeType: string): void {
    const byteCharacters = atob(base64File);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
        type: mimeType,
    });

    downloadFileInBrowser(filename, URL.createObjectURL(blob));
}

export function downloadArrayBufferFile (arrayBuffer: ArrayBuffer, filename: string, mimeType: string): void {
    const blob = new Blob([arrayBuffer], { type: mimeType });
    downloadFileInBrowser(filename, URL.createObjectURL(blob));
}
